export default __webpack_public_path__ + "static/media/connectivity.80ff38e3.svg";